import { render, staticRenderFns } from "./PayoutsInProgressTable.vue?vue&type=template&id=4bffea14&scoped=true&"
import script from "./PayoutsInProgressTable.vue?vue&type=script&lang=js&"
export * from "./PayoutsInProgressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bffea14",
  null
  
)

export default component.exports